// Which sets have box art: dims in mm, the six face textures for the
// spinnable box (?view=box), the flat dieline art, and the printable
// dieline PDF. Baked by workbench/box3d/gen-faces.ts (or, once it exists,
// the box-art pipeline's own bake) into boxes.json — everything else has
// no box yet, and the reader hides its box button rather than link to a
// 404.
import manifest from './boxes.json'

export interface BoxFaces {
  front: string
  back: string
  left: string
  right: string
  top: string
  bottom: string
}

export interface BoxArt {
  dims: { w: number; h: number; d: number }
  faces: BoxFaces
  flat: string
  // The old pre-rendered 3D mockup: not shown any more (the spinnable box
  // replaced it) but a good loading placeholder — already the box's own
  // colours, where the 3D view is still a grey cube waiting on textures.
  mockup: string
  dieline: string | null
}

const BOXES: Record<string, BoxArt> = manifest

export function boxArtFor(slug: string): BoxArt | null {
  return BOXES[slug] ?? null
}
